import { AccountInfo } from '@azure/msal-browser';

import { getMsalClient } from '../client';

export const getAccount = (): AccountInfo | undefined => {
  const currentAccounts: AccountInfo[] = getMsalClient().getAllAccounts();
  return currentAccounts?.[0];
};
